import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import "../../assets/css/Care-Registration.css";
import { AddServicesAction } from "../../redux/actions/auth";
import { useNavigate } from "react-router-dom";

const AddServices = ({ navigation, auth, services, addServices }) => {
    const navigate = useNavigate();

    useEffect(() => {
        let ids = auth.user.services.map((singleService) =>
            singleService.service_id.toString()
        );
        setServiceIds(ids);
    }, []);

    const [serviceIds, setServiceIds] = useState([]);

    const submit = async () => {
        addServices(serviceIds).then(() => {
            navigate("/my-services");
        });
    };
    return (
        <>
            <Header />
            <div className="care-registration">
                <div className="container">
                    <section>
                        <div className="row">
                            {services.map((service) => {
                                return (
                                    <div
                                        className="col-md-2"
                                        key={service.id.toString()}
                                    >
                                        <label className="radioss">
                                            <input
                                                type="checkbox"
                                                checked={serviceIds.includes(
                                                    service.id.toString()
                                                )}
                                                name="service_ids[]"
                                                onChange={() => {
                                                    if (
                                                        serviceIds.includes(
                                                            service.id.toString()
                                                        )
                                                    ) {
                                                        let serviceIdss =
                                                            serviceIds.filter(
                                                                (serviceId) =>
                                                                    serviceId !=
                                                                    service.id.toString()
                                                            );
                                                        setServiceIds(
                                                            serviceIdss
                                                        );
                                                    } else {
                                                        let serviceIdss = [
                                                            ...serviceIds,
                                                        ];
                                                        serviceIdss.push(
                                                            service.id.toString()
                                                        );
                                                        setServiceIds(
                                                            serviceIdss
                                                        );
                                                    }
                                                }}
                                            />
                                            <span className="checkmark">
                                                <div className="service_box">
                                                    <div className="img_box">
                                                        <figure>
                                                            <img
                                                                src={
                                                                    config.assetUrl +
                                                                    "/uploads/" +
                                                                    service.image
                                                                }
                                                                alt=""
                                                            />
                                                        </figure>
                                                    </div>
                                                    <div className="txtDv">
                                                        <h5 className="child-care-service">
                                                            {service.title}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </span>
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={submit}
                        >
                            Save
                        </button>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    services: state.services,
});

const mapDispatchToProps = (dispatch) => ({
    addServices: async (service_ids) =>
        dispatch(await AddServicesAction(service_ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddServices);
